/**
 * for Tealium only the 1st ad is rendered by marketing team.
 * For subsequent ads, call the pclnEventDispatcher.dispatch with the adId only ONCE.
 */

export function AdsRenderModal() {
  this['div-gpt-ad-1447089861109-0'] = false
  this['div-gpt-ad-1447090052411-0'] = false
  this['div-gpt-ad-1447090103302-0'] = false
  this['div-gpt-ad-1447090172253-0'] = false
}
